import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VoiceCalculator from '../components/VoiceCalculator';
import './Jobs.css';
export default function VoiceCounter() {
  return <div className="body jobs-frame"><Header title="声優用文字数・料金カウンター | ASMRキリスト教会" description="1文字1.5円（税抜）。バイノーラル・朗読動画・源泉徴収に対応。請求書も作成できます。" url="https://www.asmrchurch.com/jobs/voice-counter" image="https://www.asmrchurch.com/static/images/jobs/counter-og.jpg" subon={false} /><main className="jobs-page"><nav className="jobs-breadcrumb"><a href="/jobs">Jobs・仕事一覧</a></nav><header className="jobs-hero"><p className="jobs-eyebrow">Voice tools</p><h1>声優用 文字数・料金カウンター</h1><p>原稿から朗読料を計算。請求書まで、ここで。</p></header><VoiceCalculator /></main><Footer /></div>;
}
